
















import { defineComponent, computed, PropType } from '@nuxtjs/composition-api';
import type { UspType } from './BuySectionUsps.vue';

export default defineComponent({
  name: 'BuySectionUspDrawer',
  props: {
    activeUsp: { type: Object as PropType<UspType>, default: null }
  },
  setup(props) {
    const hasLink = computed(
      () => props.activeUsp?.url && props.activeUsp?.title
    );

    const handleCtaClick = () => {
      if (!props.activeUsp?.url) return;
      window.open(props.activeUsp.url, '_blank');
    };

    return {
      hasLink,
      handleCtaClick
    };
  }
});
